import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  youEarnedPointsTitle: {
    id: `${scope}.youEarnedPointsTitle`,
    defaultMessage: 'You earned {points, plural, one {# point} other {# points}}',
  },
  pointText: {
    id: `${scope}.pointText`,
    defaultMessage: 'points',
  },
  pointsAssignmentText: {
    id: `${scope}.pointsAssignmentText`,
    defaultMessage: 'Points can be used to purchase products and services from our participating coupons',
  },
  statusText: {
    id: `${scope}.statusText`,
    defaultMessage: 'Business marketer',
  },
  yourStatusText: {
    id: `${scope}.yourStatusText`,
    defaultMessage: 'You are now a {statusText}! You can share your code with businesses',
  },
  referralProgramCodeTitle: {
    id: `${scope}.referralProgramCodeTitle`,
    defaultMessage: 'Share and Earn',
  },
  referralsText: {
    id: `${scope}.referralsText`,
    defaultMessage: 'Friends',
  },
  referralCodeInstructionText: {
    id: `${scope}.referralProgramCode`,
    defaultMessage: 'Share this QR code with your {targetText} and earn 500 points every year they join Premium!',
  },
  paymentInformationTitle: {
    id: `${scope}.paymentInformationTitle`,
    defaultMessage: 'Payment information',
  },
  renewalDate: {
    id: `${scope}.renewalDate`,
    defaultMessage: '{renewalDate, date, ::MMMddyyyy}',
  },
  yourRenewalDateText: {
    id: `${scope}.yourRenewalDateText`,
    defaultMessage: 'Your renewal date is {renewalDateText}',
  },
  legalInformationTitle: {
    id: `${scope}.legalInformationTitle`,
    defaultMessage: 'Legal information',
  },
  privacyPolicyText: {
    id: `${scope}.privacyPolicyText`,
    defaultMessage: 'Privacy Policy',
  },
  termsOfServiceText: {
    id: `${scope}.termsOfServiceText`,
    defaultMessage: 'Terms of Service',
  },
  hasFreePlan: {
    id: `${scope}.hasFreePlan`,
    defaultMessage: 'You have free subscription',
  },
  subscribe: {
    id: `${scope}.subscribe`,
    defaultMessage: 'Subscribe',
  },
  deleteAccountText: {
    id: `${scope}.deleteAccountText`,
    defaultMessage: 'Delete Account',
  },
  pageTitle: {
    id: `${scope}.pageTitle`,
    // Rich-text tag lets the page render "Account" in a heavier weight
    // (per the redesign) without splitting this into two separate,
    // hard-to-translate strings.
    defaultMessage: 'My <strong>Account</strong>',
  },
  totalFollowersLabel: {
    id: `${scope}.totalFollowersLabel`,
    defaultMessage: 'Total Followers',
  },
  totalReferralsLabel: {
    id: `${scope}.totalReferralsLabel`,
    defaultMessage: 'Total Referrals',
  },
  totalEarnedLabel: {
    id: `${scope}.totalEarnedLabel`,
    defaultMessage: 'Total Saved',
  },
  newFeatureLaunchTitle: {
    id: `${scope}.newFeatureLaunchTitle`,
    defaultMessage: 'New Feature Launch.',
  },
  newFeatureLaunchSubtitle: {
    id: `${scope}.newFeatureLaunchSubtitle`,
    defaultMessage: 'Boost your Coupon Reach!',
  },
  couponPointsLabel: {
    id: `${scope}.couponPointsLabel`,
    defaultMessage: 'Coupon Points',
  },
  totalUsedCouponsLabel: {
    id: `${scope}.totalUsedCouponsLabel`,
    defaultMessage: 'Total Used Coupons',
  },
  monthlyCouponLabel: {
    id: `${scope}.monthlyCouponLabel`,
    defaultMessage: 'Monthly Coupon',
  },
  monthlyCouponCountText: {
    id: `${scope}.monthlyCouponCountText`,
    defaultMessage: 'Count {count} — Used {used}',
  },
  premiumMemberBadge: {
    id: `${scope}.premiumMemberBadge`,
    defaultMessage: 'Premium Member',
  },
  subscribeToPremium: {
    id: `${scope}.subscribeToPremium`,
    defaultMessage: 'Subscribe To Premium',
  },
  // New: two-line label sitting above the "Subscribe To Premium" tile action
  // for free-plan users ("Increase Monthly" normal weight, "Coupon Count" in
  // a smaller caps-style span) — added for the dashboard redesign.
  increaseMonthlyCouponCountText: {
    id: `${scope}.increaseMonthlyCouponCountText`,
    defaultMessage: 'Increase Monthly <small>Coupon Count</small>',
  },
  membershipTitle: {
    id: `${scope}.membershipTitle`,
    defaultMessage: 'Membership',
  },
  legalInfoTitle: {
    id: `${scope}.legalInfoTitle`,
    defaultMessage: 'Legal info',
  },
  userGuidelinesText: {
    id: `${scope}.userGuidelinesText`,
    defaultMessage: 'User Guidelines',
  },
  accountMenuTitle: {
    id: `${scope}.accountMenuTitle`,
    defaultMessage: 'Account Menu',
  },
  usedCouponsMenuText: {
    id: `${scope}.usedCouponsMenuText`,
    defaultMessage: 'Used Coupons',
  },
  favoritesMenuText: {
    id: `${scope}.favoritesMenuText`,
    defaultMessage: 'Favourites',
  },
  myReferralsMenuText: {
    id: `${scope}.myReferralsMenuText`,
    defaultMessage: 'My Referrals',
  },
  logoutMenuText: {
    id: `${scope}.logoutMenuText`,
    defaultMessage: 'Logout',
  },
  editProfileText: {
    id: `${scope}.editProfileText`,
    defaultMessage: 'Edit profile',
  },
  // New: alt text for the promo banner creative (now a full illustrated
  // image asset rather than text rendered over a gradient).
  newFeatureLaunchAlt: {
    id: `${scope}.newFeatureLaunchAlt`,
    defaultMessage: 'Earn 500 Points! Each referral that joins Premium earns you 500 points every year',
  },
});